// src/components/Settings/Layout/PrivacySettings.js

import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import PrivacySelector from "../Utils/PrivacySelector";
// import { ThemeContext } from "../../../../context/ThemeContext";
import "../Styles/PrivacySettings.css"

const PrivacySettings = () => {
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  // const { theme } = useContext(ThemeContext);

  // useEffect(() => {
  //   import(`../Styles/themes/${theme}/themes.css`)
  //     .then(() => console.log(`Loaded ${theme} styles for PrivacySettings`))
  //     .catch(() => console.error(`Theme CSS not found for ${theme}`));
  // }, [theme]);

  return (
    <div className="st-panel priv-root">
      <h2 className="st-panel-title">🔒 Privacy Settings</h2>
      <p className="st-panel-subtitle">
        Customize how your personal data is handled and shared across the platform.
      </p>

      {/* Master Toggle */}
      <div className="priv-master-toggle">
        <div className="priv-master-toggle-info">
          <span className="priv-master-toggle-title">
            {privacyPolicyAccepted ? "✅ Privacy Customization Active" : "Configure Privacy Options"}
          </span>
          <span className="priv-master-toggle-desc">
            {privacyPolicyAccepted
              ? "Your custom privacy settings are active. Adjust them below."
              : "Enable to customize privacy options for your account and data sharing preferences."}
          </span>
        </div>
        <label className="st-switch">
          <input
            type="checkbox"
            checked={privacyPolicyAccepted}
            onChange={() => setPrivacyPolicyAccepted(!privacyPolicyAccepted)}
          />
          <span className="st-slider" />
        </label>
      </div>

      {/* Privacy Selector Component */}
      {privacyPolicyAccepted && (
        <div className="priv-content">
          <PrivacySelector />
        </div>
      )}

      {/* Info Banner */}
      {!privacyPolicyAccepted && (
        <div className="priv-info-banner" style={{background: "rgba(36,36,45,0.2)", border: "1px solid gray"}}>
          <span>ℹ️</span>
          <p>
            Enable the toggle above to customize your privacy settings. Control data collection,
            third-party sharing, analytics, and personalization preferences.{" "}
            <Link to="/privacy-info" className="priv-link">Learn more</Link>
          </p>
        </div>
      )}
    </div>
  );
};

export default PrivacySettings;
